/*
 * Laser Xpressions Dawn 16 migration runtime
 * Pass 2: restores slider and legacy utility behavior without replacing Dawn 16 core JavaScript.
 */
(function () {
  'use strict';

  var retryCount = 0;
  var maxRetries = 40;

  function jqReady() {
    return !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.slick);
  }

  function initMainBanners(scope) {
    var $ = window.jQuery;
    var $scope = scope ? $(scope) : $(document);

    $scope.find('.lx-main-banner').addBack('.lx-main-banner').each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) return;

      var autoplaySetting = $slider.attr('data-autoplay');
      var autoplay = autoplaySetting === undefined ? true : autoplaySetting === 'true';
      var autoplaySpeed = parseInt($slider.attr('data-autoplay-speed'), 10) || 5000;

      $slider.slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        speed: 500
      });
    });
  }

  function initCategorySliders(scope) {
    var $ = window.jQuery;
    var $scope = scope ? $(scope) : $(document);

    $scope.find('.lx-category-slider').addBack('.lx-category-slider').each(function () {
      var $slider = $(this);

      if (window.innerWidth < 750) {
        if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
        return;
      }

      if ($slider.hasClass('slick-initialized')) return;

      $slider.slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
          { breakpoint: 750, settings: 'unslick' }
        ]
      });
    });
  }

  function initLegacyProductSliders(scope) {
    var $ = window.jQuery;
    var $scope = scope ? $(scope) : $(document);

    $scope.find('.lx-product-slider').addBack('.lx-product-slider').each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) return;

      $slider.slick({
        dots: false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
          { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
          { breakpoint: 481, settings: { slidesToShow: 2, slidesToScroll: 1 } }
        ]
      });
    });
  }

  function initLogoSliders(scope) {
    var $ = window.jQuery;
    var $scope = scope ? $(scope) : $(document);

    $scope.find('.lx-logo-slider').addBack('.lx-logo-slider').each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) return;

      function intData(name, fallback) {
        var value = parseInt($slider.attr(name), 10);
        return Number.isFinite(value) ? value : fallback;
      }

      function boolData(name, fallback) {
        var value = $slider.attr(name);
        if (typeof value === 'undefined') return fallback;
        return String(value).toLowerCase() === 'true';
      }

      var desktopSlides = intData('data-lxi-logo-desktop', 4);
      var tabletSlides = intData('data-lxi-logo-tablet', 3);
      var mobileSlides = intData('data-lxi-logo-mobile', 2);
      var autoplay = boolData('data-lxi-logo-autoplay', true);
      var autoplaySpeed = intData('data-lxi-logo-autoplay-speed', 2000);
      var arrows = boolData('data-lxi-logo-arrows', false);
      var mobileDots = boolData('data-lxi-logo-mobile-dots', true);

      $slider.slick({
        dots: false,
        arrows: arrows,
        slidesToShow: desktopSlides,
        slidesToScroll: 1,
        infinite: true,
        speed: 300,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: tabletSlides, slidesToScroll: 1, infinite: true, dots: mobileDots } },
          { breakpoint: 600, settings: { slidesToShow: mobileSlides, slidesToScroll: 1, dots: mobileDots } },
          { breakpoint: 481, settings: { slidesToShow: mobileSlides, slidesToScroll: 1, dots: mobileDots } }
        ]
      });
    });
  }

  function initLegacyTabs(scope) {
    var $ = window.jQuery;
    var $scope = scope ? $(scope) : $(document);

    $scope.find('#tabs-nav').addBack('#tabs-nav').each(function () {
      var $nav = $(this);
      if ($nav.data('lxi-tabs-ready')) return;
      $nav.data('lxi-tabs-ready', true);

      var $container = $nav.closest('section, .shopify-section');
      if (!$container.length) $container = $(document.body);

      $nav.find('li:first-child').addClass('active');
      $container.find('.tab-content').hide().first().show();

      $nav.on('click.lxiTabs', 'li', function (event) {
        var href = $(this).find('a').attr('href');
        if (!href || href.charAt(0) !== '#') return;

        event.preventDefault();
        $nav.find('li').removeClass('active');
        $(this).addClass('active');
        $container.find('.tab-content').hide();
        $container.find(href).fadeIn();
      });
    });
  }

  function initJqueryUtilities(scope) {
    var $ = window.jQuery;
    var $scope = scope ? $(scope) : $(document);

    $scope.find('#toggle-categories').addBack('#toggle-categories').each(function () {
      var $button = $(this);
      if ($button.data('lxi-toggle-ready')) return;
      $button.data('lxi-toggle-ready', true);

      if (
        window.innerWidth < 750 &&
        (window.location.pathname === '/pages/personal' || window.location.pathname === '/pages/corporate')
      ) {
        $('.lx-megamenu-mobile').show();
        $button.addClass('active-categories');
      }

      $button.on('click.lxiCategories', function () {
        $('.lx-megamenu-mobile').slideToggle('slow');
        $button.toggleClass('active-categories');
      });
    });

    $scope.find('#toggle-specs').addBack('#toggle-specs').each(function () {
      var $button = $(this);
      if ($button.data('lxi-specs-ready')) return;
      $button.data('lxi-specs-ready', true);
      $button.on('click.lxiSpecs', function () {
        $('.lx-specs-wrap').slideToggle('fast');
        $button.toggleClass('active-specs');
      });
    });
  }

  function initSlickFeatures(scope) {
    if (!jqReady()) {
      if (retryCount++ < maxRetries) {
        window.setTimeout(function () { initSlickFeatures(scope); }, 125);
      }
      return;
    }

    retryCount = 0;
    initMainBanners(scope);
    initCategorySliders(scope);
    initLegacyProductSliders(scope);
    initLogoSliders(scope);
    initLegacyTabs(scope);
    initJqueryUtilities(scope);
  }

  function initBreadcrumbContext() {
    var breadcrumb = document.getElementById('custom-collection-breadcrumb');
    var gridContainer = document.getElementById('ProductGridContainer');
    if (!breadcrumb || !gridContainer) return;

    var contextKeys = ['nav_text', 'nav_link', 'group_text', 'group_link', 'cat_text', 'cat_link', 'bc_text', 'bc_link'];

    function currentContext() {
      var params = new URLSearchParams(window.location.search);
      var context = {};
      var hasExplicitContext = false;

      contextKeys.forEach(function (key) {
        var value = params.get(key);
        if (value) {
          context[key] = value;
          hasExplicitContext = true;
        }
      });

      if (hasExplicitContext) return context;

      var parentText = breadcrumb.dataset.lxiDefaultParentText || '';
      var parentLink = breadcrumb.dataset.lxiDefaultParentLink || '';
      var catText = breadcrumb.dataset.lxiDefaultCatText || '';
      var catLink = breadcrumb.dataset.lxiDefaultCatLink || '';

      if (parentText) context.bc_text = parentText;
      if (parentLink) context.bc_link = parentLink;
      if (catText) context.cat_text = catText;
      if (catLink) context.cat_link = catLink;

      return context;
    }

    function getImageContext(context) {
      var params = new URLSearchParams(window.location.search);
      var explicit = params.get('lxi_image');
      if (explicit) return explicit;

      var catLink = context.cat_link || '';
      if (!catLink) return '';

      try {
        var categoryUrl = new URL(catLink, window.location.origin);
        var match = categoryUrl.pathname.match(/^\/collections\/all\/([^/]+)\/?$/i);
        if (match) return decodeURIComponent(match[1]).toLowerCase();
        match = categoryUrl.pathname.match(/^\/collections\/([^/]+)\/?$/i);
        return match ? decodeURIComponent(match[1]).toLowerCase() : '';
      } catch (e) {
        return '';
      }
    }

    function addContext(href, context, includeImageContext) {
      if (!href) return href;

      try {
        var url = new URL(href, window.location.origin);
        contextKeys.forEach(function (key) {
          if (context[key]) url.searchParams.set(key, context[key]);
        });

        if (includeImageContext) {
          var imageContext = getImageContext(context);
          if (imageContext) url.searchParams.set('lxi_image', imageContext);
        }

        return url.pathname + url.search + url.hash;
      } catch (e) {
        return href;
      }
    }

    function decorateGrid() {
      var context = currentContext();
      var hasContext = contextKeys.some(function (key) { return !!context[key]; });
      if (!hasContext) return;

      gridContainer.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        var href = link.getAttribute('href');
        if (href) link.setAttribute('href', addContext(href, context, true));
      });

      gridContainer.querySelectorAll('.pagination a[href]').forEach(function (link) {
        var href = link.getAttribute('href');
        if (href) link.setAttribute('href', addContext(href, context, false));
      });
    }

    function preserveContextInFacetForms() {
      var context = currentContext();

      document.querySelectorAll('facet-filters-form form').forEach(function (form) {
        contextKeys.forEach(function (key) {
          if (!context[key]) return;

          var input = form.querySelector('input[data-lxi-breadcrumb-context="' + key + '"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.dataset.lxiBreadcrumbContext = key;
            form.appendChild(input);
          }
          input.value = context[key];
        });
      });
    }

    decorateGrid();
    preserveContextInFacetForms();

    if (!gridContainer.dataset.lxiBreadcrumbObserver) {
      gridContainer.dataset.lxiBreadcrumbObserver = 'true';
      var observer = new MutationObserver(function () {
        decorateGrid();
        preserveContextInFacetForms();
      });
      observer.observe(gridContainer, { childList: true, subtree: true });
    }
  }

  function initBackToTop() {
    var button = document.querySelector('.lxi-back-to-top');
    if (!button || button.dataset.lxiReady) return;
    button.dataset.lxiReady = 'true';

    function updateVisibility() {
      button.classList.toggle('is-visible', window.scrollY > 500);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    updateVisibility();
  }

  function init(scope) {
    initSlickFeatures(scope || document);
    initBreadcrumbContext();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      if (jqReady()) initCategorySliders(document);
    }, 180);
  });
})();
